export default {
  hyattSignInButton: 'تسجيل الدخول إلى World of Hyatt',
  points: 'نقاط',
  signIn: 'تسجيل الدخول',
  signOut: 'تسجيل الخروج',
};
